import ApiClient from '@services/ApiClient';

export default {
    create(data) {
        return ApiClient.post('/orders', data);
    },

    index(offerType, page, sortedBy, sortedType) {
        return ApiClient.get(`/user/orders/${offerType}?page=${page}&order-by=${sortedBy}&order-type=${sortedType}`);
    },

    show(offerType, id) {
        return ApiClient.get(`/user/orders/${offerType}/${id}`);
    },

    showByCookie(offerType, id) {
        return ApiClient.get(`/orders/show-by-cookie/${offerType}/${id}`);
    },

    setBackofficeOrder(order_number, bo_order_id, bo_order_number) {
        return ApiClient.post('/orders/set-backoffice-order', {
            order_number,
            bo_order_id,
            bo_order_number,
        });
    },

    sendInvoiceData(order_id, order_number, invoice) {
        return ApiClient.post('/orders/send-invoice-data', {
            bo_order_id: order_id,
            bo_order_number: order_number,
            invoice: invoice,
        });
    },
};
